var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "task_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8319",
    "data-name": "Path 8319",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8320",
    "data-name": "Path 8320",
    d: "M19.41,7.41,14.58,2.58A2,2,0,0,0,13.17,2H6A2,2,0,0,0,4.01,4L4,20a2,2,0,0,0,1.99,2H18a2.006,2.006,0,0,0,2-2V8.83A2.006,2.006,0,0,0,19.41,7.41Zm-9.18,9.88L8.11,15.17a1,1,0,0,1,0-1.41h0a1,1,0,0,1,1.41,0l1.41,1.41,3.54-3.54a1,1,0,0,1,1.41,0h0a1,1,0,0,1,0,1.41l-4.24,4.24A.987.987,0,0,1,10.23,17.29ZM14,9a1,1,0,0,1-1-1V3.5L18.5,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.8ea7fc54f8ba67e0ec6b032e544d60dd.svg";
export { ForwardRef as ReactComponent };